import { Component, Input, QueryList, ViewChildren } from '@angular/core';
import { Account } from '../../../models/account/account';
import { Person } from '../../../models/person/person';
import { FormMode } from '../../../core/constants';
import { UIErrorHandler } from '../../../core/uiErrorHandler';
import {
  TextInputComponent,
  TextModes,
} from '../../ui/controls/text-input/text-input.component';
import { DdlInputComponent } from '../../ui/controls/ddl-input/ddl-input.component';
import { iValidatedControl } from '../../ui/controls/iValidatedControl';
import { AccountService } from '../../../models/account/accountService';
import { SiteDataService } from '../../../models/ui/siteDataService';
import { BaseComponent } from '../../baseComponent';

@Component({
  selector: 'app-account-details-form',
  templateUrl: './account-details-form.component.html',
  standalone: false,
})
export class AccountDetailsFormComponent extends BaseComponent {
  @Input() account: Account = new Account(Account.createEmpty());
  @Input() mode: FormMode = FormMode.View;
  @Input() hideGroupAndBrand: boolean = false;

  @ViewChildren(TextInputComponent) validatedTextBoxes:
    | QueryList<TextInputComponent>
    | undefined;
  @ViewChildren(DdlInputComponent) validatedDropDowns:
    | QueryList<DdlInputComponent>
    | undefined;

  //FormModeEnum = FormMode;
  InputTextModesEnum = TextModes;

  _account: Account = new Account(Account.createEmpty());
  _owner: Partial<Person> = Person.createEmpty();

  //brandOptions: ListItem[] = [];
  //groupOptions: ListItem[] = [];

  //allowEditAccount:boolean = false;
  allowEditBilling: boolean = true;
  allowEditUsers: boolean = true;
  allowEditContact: boolean = true;
  allowEditSettings: boolean = true;
  allowEditProcessors: boolean = true; // TODO: Update this

  // These are required because child components use this constructor explicitly.
  constructor(
    private siteDataService: SiteDataService,
    private uiErrorHandler: UIErrorHandler,
    private accountService: AccountService,
  ) {
    super();
  }

  ngOnInit() {
    this.selectBookmark('accountContactsContainer');
  }

  public getAccountInfo(): Account {
    this._account.owner = this._owner;
    return this._account;
  }

  public clearForm() {
    this._account = new Account(Account.createEmpty());
    this._owner = Person.createEmpty();
  }

  public getValidatedControls(): iValidatedControl[] {
    let all: iValidatedControl[] = [];

    if (this.validatedTextBoxes) {
      all = all.concat(this.validatedTextBoxes.toArray());
    }

    if (this.validatedDropDowns) {
      all = all.concat(this.validatedDropDowns.toArray());
    }

    return all;
  }

  public validateForm(): any[] {
    let errors: any[] = [];

    if (this.validatedTextBoxes) {
      this.validatedTextBoxes.forEach((component) => {
        if (!component.validate()) {
          errors.push({
            componentId: component.id,
            componentLabel: component.labelValue,
            componentGroup: component.groupName,
          });
        }
      });
    }

    if (this.validatedDropDowns) {
      this.validatedDropDowns.forEach((component) => {
        if (!component.validate()) {
          errors.push({
            componentId: component.id,
            componentLabel: component.labelValue,
            //componentGroup: component.groupName
          });
        }
      });
    }

    return errors;
  }

  handleSaved(saved: boolean) {
    //this.saved.emit(saved);
  }

  btnEdit_click() {
    //this.copyModelData(this.merchant, this.data);
    this.mode = FormMode.Edit;
  }

  btnCancel_click() {
    this.mode = FormMode.View;
  }

  selectBookmark(selector: string) {
    // hide all tabs
    let tabs = document.getElementsByClassName('content selected');
    for (var i = 0; i < tabs.length; i++) {
      tabs[i].classList.remove('selected');
    }

    let tabContents = document.getElementsByClassName('tabContent selected');
    for (var i = 0; i < tabContents.length; i++) {
      tabContents[i].classList.remove('selected');
    }

    let selectedTab = document.getElementById('tab_' + selector);
    selectedTab?.children[0].classList.add('selected');

    let selectedTabContent = document.getElementById(selector);

    selectedTabContent?.classList.add('selected');

    //scrollToTop(selector, this.scrollToYoffset);
  }

  public btnSave_click() {
    var that = this;
  }
}
